import { render, staticRenderFns } from "./EnquiryViaFormStatItem.vue?vue&type=template&id=6a6654ba&"
import script from "./EnquiryViaFormStatItem.vue?vue&type=script&lang=js&"
export * from "./EnquiryViaFormStatItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports